import { render, staticRenderFns } from "./information-detail.view.vue?vue&type=template&id=1e4b3fa6&"
import script from "./information-detail.view.vue?vue&type=script&lang=ts&"
export * from "./information-detail.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports